import React, { useEffect, useState } from "react";
import GetOrders from "../api/GetOrders";
import GetOrdersByRegion from "../api/GetOrdersByRegion";
import formatDate from "../../../utils/FormatDate";
import OrderListTable from "../components/OrderListTable";
import * as XLSX from "xlsx";

// Order Page
const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [filterOrders, setFilterOrders] = useState([]);
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterDistributorOrPhone, setFilterDistributorOrPhone] = useState("");
  const [filterStatus, setFilterStatus] = useState(0);

  // getting Order Data using Effect
  useEffect(() => {
    const getOrderData = async () => {
      JSON.parse(localStorage.getItem("user")).privilege === 1
        ? setOrders(await GetOrders())
        : setOrders(await GetOrdersByRegion());
    };
    getOrderData();
  }, []);

  // set Filter Order
  useEffect(() => {
    setFilterOrders(orders);
  }, [orders]);

  // handler searching button
  const handleSearchForm = (e) => {
    e.preventDefault();
    let filtered = orders;

    if (filterDateFrom) {
      // process filter Date From and End
      filtered = filtered.filter(
        (order) => formatDate(order.orderdate) >= formatDate(filterDateFrom)
      );
    }
    if (filterDateTo) {
      // process filter Date From and End
      filtered = filtered.filter(
        (order) => formatDate(order.orderdate) <= formatDate(filterDateTo)
      );
    }

    // searching for
    if (filterStatus !== 0) {
      filtered = filtered.filter((order) => order.status === filterStatus);
    }

    // searching by Name
    if (filterDistributorOrPhone) {
      // searching For Distributor Name Or Phone
      const filter_distr = filtered.filter((order) =>
        order.name.toLowerCase().includes(filterDistributorOrPhone)
      );
      const filter_phone = filtered.filter((order) =>
        order.phone.toLowerCase().includes(filterDistributorOrPhone)
      );
      filtered = [...filter_phone, ...filter_distr];
    }
    setFilterOrders(filtered);
  };

  // Export to Excel
  const exportToExcel = () => {
    const dataToExport = filterOrders.map((order) => {
      const extractedData = {
        "إسم العميل": order.name,
        "منطقة العميل": order.regionNameAr,
        "السعر العراقي": order.totalIraqiprice,
        "السعر بالدولار": order.totalUsdprice,
        "حالة الطلب":
          order.status === 1 ? "طلب جديد" : order.status === 2 ? " قيد التنفيذ" : "تم الإنتهاء منه",
        "تاريخ الطلب": formatDate(order.orderdate),
        "عدد العناصر": order.items.length,
      };
      return extractedData;
    });
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const date = new Date().toISOString().slice(0, 10); // Get the current date in YYYY-MM-DD format
    const fileName = `orders_${date}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };
  return (
    <>
      <section className="body-font text-gray-600">
        <div className="container mx-auto py-8">
          <div className="mb-12 flex flex-col md:flex-row-reverse justify-between items-center md:border-b pb-2 ">
            <h2 className="text-right text-2xl font-bold p-4">الطلبات</h2>
            <form className="flex flex-col p-4 items-center md:flex-row-reverse md:items-center">
              <div className="mb-2 mx-2 flex flex-row-reverse items-center">
                <label className="p-2 mx-2">من تاريخ</label>
                <input
                  type="date"
                  className="py-2 px-2 bg-white border rounded-lg"
                  dir="trl"
                  value={filterDateFrom}
                  onChange={(e) => {
                    setFilterDateFrom(e.target.value);
                  }}
                />
              </div>
              <div className="mb-2 mx-2 flex flex-row-reverse items-center">
                <label className="p-2 mx-2">حتى تاريخ</label>
                <input
                  type="date"
                  className="py-2 px-2 bg-white border rounded-lg"
                  dir="trl"
                  value={filterDateTo}
                  onChange={(e) => {
                    setFilterDateTo(e.target.value);
                  }}
                />
              </div>
              <div className="mb-2 mx-2 flex flex-row-reverse items-center">
                <select
                  className="w-full p-2 border rounded-lg"
                  dir="rtl"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(Number(e.target.value))}
                >
                  <option value="0" spellCheck="">
                    غير محدد
                  </option>
                  <option value="1">طلب جديد</option>
                  <option value="2">قيد التنفيذ</option>
                  <option value="3">تم الإنتهاء منه</option>
                </select>
              </div>
              <div className="mb-2 mx-2 flex flex-row-reverse items-center">
                <input
                  type="text"
                  placeholder="   إسم الموزع أو رقم الهانف "
                  className="py-2 px-2 bg-white border rounded-lg"
                  dir="trl"
                  value={filterDistributorOrPhone}
                  onChange={(e) => setFilterDistributorOrPhone(e.target.value)}
                />
              </div>
              <div className="mb-2 mx-2 flex flex-row-reverse items-center">
                <button
                  type="submit"
                  onClick={handleSearchForm}
                  className="py-2 px-4 bg-blue-500 rounded text-mld text-white"
                >
                  بحث
                </button>

                <button
                  type="button"
                  onClick={exportToExcel}
                  className="mx-4 py-2 px-4 bg-blue-500 rounded text-mld text-white"
                >
                  إستخراج لملف إكسل
                </button>
              </div>
            </form>
          </div>
          <div className="-m-4 flex flex-wrap flex-row-reverse">
            <OrderListTable orders={filterOrders} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Orders;
